/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo } from "react";
import { useFirebaseStorage } from "utils/hooks/useFirebaseStorage";
import { convertQueue, getRecord, getRecordDetail, deleteRecordFile, getRecordPagination } from "api/convert";
import { getSpecificationProductFilter } from "api/specification";
import { v4 as uuidv4 } from "uuid";
import { useMachine } from "@xstate/react";
import { fetchMachine, FetchEventType, FetchStates } from "machines/fetchMachine";
import { sliceTableData, setSelectOptions, getSchoolYear } from "utils/common";
import { Table, Pagination, Button, Icon, Upload, Select, Loading } from "common-components";
import { Modal, Tabs, Image, Checkbox } from "antd";
import { getTime, format } from "date-fns";
import queryString from "query-string";
import { useLocation, useHistory } from "react-router-dom";
import openNotificationWithIcon from "utils/hooks/useNotification";
import { getQuestionHtml } from "api/bank";
import { Breadcrumb } from "components";
import {
	UiHomePage,
	BtnGroup,
	UiPopupContainer,
	UiRuleModalContent,
	UiButtons,
	UiLink,
	UiStatus,
	UiQuesDetail,
	UiTableBox,
	UiLoadingBox,
} from "./HomePage.style";
import { FileCheck } from "components";

/**
 * 試題入庫
 */

const { Header, Body, Row, Item } = Table;

const breadcrumbList = [
	{
		icon: "unarchive",
		name: "試題入庫",
		path: "/",
	},
];

const initsearchProductDetailData = {
	year: getSchoolYear() + "",
	edu: "",
	subject: "",
	version: "",
};

const showCodeList = ["CORE_ACCOMPLISHMENT", "PERFORMANCE", "LEARN_CONTENT", "KNOWLEDGE"];

const filterTypeOptions = [
	{
		name: "顯示全部題目",
		value: "all",
	},
	{
		name: "僅顯示成功",
		value: 0,
	},
	{
		name: "僅顯示失敗",
		value: 1,
	},
];

const ButtonGroup = ({ item, onDetailPopupHandle, onDeleteHandle, onDownloadHandle, onReSubmitHandle }) => {
	const [deletePopupState, setDeletePopupState] = useState(false);
	const [reSubmitLoading, setReSubmitLoading] = useState(false);
	const onConfirmHandle = () => {
		onDeleteHandle(item);
		setDeletePopupState(false);
	};

	const retryBtn = () => {
		return item.allowRetry ? (
			<Button.IconButton
				variant="green"
				full={false}
				iconName="restart_alt"
				type="outLined"
				loading={reSubmitLoading}
				onClick={async () => {
					setReSubmitLoading(true);
					await onReSubmitHandle(item);
					setReSubmitLoading(false);
				}}>
				重新轉檔
			</Button.IconButton>
		) : (
			""
		);
	};

	switch (item.status) {
		case "Finish":
			return (
				<BtnGroup>
					{retryBtn()}
					<Button.IconButton
						variant="orange"
						full={false}
						iconName="visibility"
						onClick={() => onDetailPopupHandle(item)}>
						看更多
					</Button.IconButton>
					<Button.Popconfirm
						title="確定要刪除嗎?"
						block={false}
						full={false}
						variant="red"
						onCancel={() => setDeletePopupState(false)}
						onConfirm={onConfirmHandle}
						onClick={() => setDeletePopupState(true)}
						visible={deletePopupState}>
						<Icon name="delete_forever" mr="2" />
						刪除
					</Button.Popconfirm>
				</BtnGroup>
			);
		case "Warning":
			return (
				<BtnGroup>
					{retryBtn()}
					<Button.IconButton variant="blue" full={false} iconName="save_alt" onClick={() => onDownloadHandle(item)}>
						下載
					</Button.IconButton>
					<Button.Popconfirm
						title="確定要刪除嗎?"
						block={false}
						full={false}
						variant="red"
						onCancel={() => setDeletePopupState(false)}
						onConfirm={onConfirmHandle}
						onClick={() => setDeletePopupState(true)}
						visible={deletePopupState}>
						<Icon name="delete_forever" mr="2" />
						刪除
					</Button.Popconfirm>
				</BtnGroup>
			);
		default:
			return (
				<BtnGroup>
					{retryBtn()}
					<Button.Popconfirm
						title="確定要刪除嗎?"
						block={false}
						full={false}
						variant="red"
						onCancel={() => setDeletePopupState(false)}
						onConfirm={onConfirmHandle}
						onClick={() => setDeletePopupState(true)}
						visible={deletePopupState}>
						<Icon name="delete_forever" mr="2" />
						刪除
					</Button.Popconfirm>
				</BtnGroup>
			);
	}
};

export const HomePage = () => {
	const history = useHistory();
	const [detailPopup, setDetailPopup] = useState({
		visible: false,
	});
	const initUrlParams = queryString.parse(useLocation().search);
	const [urlParams, setUrlParams] = useState(initUrlParams);
	const [isLoading, setIsLoading] = useState(false);

	const { upload } = useFirebaseStorage();

	const [uploadPopup, setUploadPopup] = useState(Object.keys(urlParams).length > 0 ? true : false);

	const [files, setFiles] = useState([]);

	const [detailPage, setDetailPage] = useState(1);

	const [pageState, setPageState] = useState({
		currentPage: 1,
		limit: 100,
	});

	const [searchProductDetailData, setSearchProductDetailData] = useState({
		year: "109",
		edu: "",
		subject: "",
		version: "",
	});

	const [detailEduSubject, setDetailEduSubject] = useState("");

	const [bookTagPath, setBookTagPath] = useState("");

	const [bookTagIsListen, setBookTagIsListen] = useState(false);

	const [checkList, setCheckedList] = useState([]);

	const [filterData, setFilterData] = useState("all");

	const [specUID, setSpecUID] = useState(null);
	// const [lockRuleSelection, setLockRuleSelection] =useState(false)
	const [stateRecord, sendRecord] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				setIsLoading(true);
				const res = await getRecordPagination(event.payload);
				const { records, totalcount, isFinished } = res.data;
				setIsLoading(false);
				return {
					records,
					totalcount,
					isFinished,
				};
			},
			deleteData: async (_c, event) => await deleteRecordFile(event.fileUID),
		},
	});

	const { records, totalcount, isFinished } = stateRecord.context.result || {};

	const [stateRecordDetail, sendRecordDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data } = await getRecordDetail(event.eduSubject, event.fileUID);
				return {
					detailList: data,
				};
			},
		},
	});

	const { detailList } = stateRecordDetail.context.result || {};

	const targetDetail = useMemo(() => {
		if (!detailList) return {};
		return detailList[detailPage - 1];
	}, [detailPage, detailList]);

	useEffect(() => {
		if (targetDetail && JSON.stringify(targetDetail) !== "{}") {
			sendGetQuestionHtml(FetchEventType.Fetch, {
				eduSubject: detailEduSubject,
				uid: targetDetail.uid,
			});
		}
	}, [targetDetail]);

	const [stateGetQuestionHtml, sendGetQuestionHtml] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await getQuestionHtml(event.eduSubject, event.uid);
				return {
					questionHtml: data,
					isSuccess,
					message,
				};
			},
		},
	});

	const { questionHtml } = stateGetQuestionHtml.context.result || {};

	const targetSelectOptions = useMemo(() => {
		let result = [];
		if (Object.keys(targetDetail).length === 0 || !targetDetail.detailImage) return result;

		result =
			targetDetail?.detailImage.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: false,
			})) || [];
		if (targetDetail.soundtracks) {
			const listenList = targetDetail.soundtracks.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: true,
			}));
			result = result.concat(listenList);
		}
		return result;
	}, [targetDetail]);

	const [stateProductDetail, sendProductDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async () => {
				const result = await getSpecificationProductFilter(searchProductDetailData.year);
				const selection = result?.data?.selection || {};
				const specList = result?.data?.specList || [];
				return {
					yearMap: setSelectOptions(selection?.yearMap) || [],
					eduMap: setSelectOptions(selection?.eduMap) || [],
					subjectMap: selection?.subjectMap || [],
					versionMap: selection?.versionMap || [],
					specList,
				};
			},
		},
	});

	const { yearMap, eduMap, subjectMap, versionMap, specList } = stateProductDetail.context.result || {};
	const subjectOptions = useMemo(() => {
		if (!subjectMap || !searchProductDetailData.edu) return [];
		return setSelectOptions(subjectMap[searchProductDetailData.edu]);
	}, [searchProductDetailData.edu]);
	const versionOptions = useMemo(() => {
		if (!versionMap || !searchProductDetailData.edu) return [];
		return setSelectOptions(versionMap[searchProductDetailData.edu]);
	}, [searchProductDetailData.edu]);
	const filterSpecList = useMemo(() => {
		const { year, edu, subject, version } = searchProductDetailData;
		if (!(year || edu || subject || version) || !specList) return [];
		return setSelectOptions(
			specList
				.filter((item) => item.eduSubject === `${edu}${subject}` && item.year === year && item.version === version)
				.map((item) => ({ name: item.name, code: item.uid })),
		);
	}, [searchProductDetailData, specList]);

	const lockRuleSelection = useMemo(() => {
		return Object.keys(urlParams).length > 0;
	}, [urlParams]);

	// const records = useMemo(() => {
	// 	if (!records) return [];
	// 	return sliceTableData(records, pageState.currentPage, pageState.limit);
	// }, [records, pageState.currentPage, pageState.limit]);

	const isCheckAll = useMemo(() => {
		if (!records) return false;
		if (checkList.length === records.length && records.length !== 0) return true;
		return false;
	}, [checkList, records]);

	const toggleDetailVisible = (item) => {
		if (!detailPopup.visible) {
			setDetailPage(1);
			setBookTagPath("");
			setBookTagIsListen(false);
			const { eduSubject, uid } = item;
			sendRecordDetail(FetchEventType.Fetch, {
				eduSubject,
				fileUID: uid,
			});
			setDetailEduSubject(eduSubject);
		}
		setDetailPopup({
			...detailPopup,
			visible: !detailPopup.visible,
		});
	};

	const toggleUploadPopupVisible = () => {
		setUploadPopup(!uploadPopup);
		setUrlParams({});
		setSearchProductDetailData(initsearchProductDetailData);
		setFiles([]);
	};

	const changeFileList = (value) => {
		setFiles(value);
	};

	const fetchRecords = (clearCheck = false) => {
		const payload = {
			failType: filterData,
			pagenumber: pageState.currentPage,
			pagesize: pageState.limit,
		};
		if (payload.failType === "all") delete payload.failType;
		sendRecord(FetchEventType.Fetch, {
			payload,
		});
		if (clearCheck) setCheckedList([]);
	};

	const submitFiles = async () => {
		if (files.length === 0) return;
		setIsLoading(true);
		await Promise.all(
			files.map(async (file) => {
				const uid = uuidv4();
				const res = await upload(`convert/${uid}_${file.name}`, file);
				const payload = {
					fileUrl: res.url,
					fileName: file.name,
					uid,
					specUID,
				};
				await doConvertQueue(payload);
			}),
		);
		setUploadPopup(false);
		setUrlParams({});
		setSearchProductDetailData(initsearchProductDetailData);
		setFiles([]);
		fetchRecords();
		setIsLoading(false);
	};

	const deleteHandle = (item) => {
		sendRecord(FetchEventType.Delete, {
			fileUID: item.uid,
		});
		setCheckedList([]);
	};

	const downloadHandle = (item) => {
		const { fileUrl, fileName } = item;
		const link = document.createElement("a");
		link.href = fileUrl;
		link.target = "_blank";
		link.download = fileName;
		link.click();
	};

	const doConvertQueue = async (payload) => {
		const { isSuccess, message } = await convertQueue(payload);
		if (!isSuccess) openNotificationWithIcon("error", message);
	};

	const doDeleteQueue = async (item) => {
		const { isSuccess, message } = await deleteRecordFile(item.uid);
		if (!isSuccess) openNotificationWithIcon("error", message);
	};

	const onReSubmitHandle = async (item) => {
		const { fileUrl, fileName, uid, specUID } = item;
		const payload = {
			fileUrl,
			fileName,
			uid,
			specUID,
		};
		await doConvertQueue(payload);
	};

	const onDetailPageChange = (currentPage) => {
		setDetailPage(currentPage);
	};

	const pageChange = (currentPage, pageSize) => {
		setPageState({
			...pageState,
			currentPage,
			limit: pageSize,
		});
	};

	const uploadStatusClassName = (status) => {
		switch (status) {
			case "Finish":
				return "";
			case "Checking":
			case "Waiting":
			case "Pending":
				return "loading";
			default:
				return "error";
		}
	};

	const onUpdateRuleChange = (type, value) => {
		if (type === "year") {
			setSearchProductDetailData({
				...searchProductDetailData,
				[type]: value,
				edu: "",
				subject: "",
				version: "",
			});
		} else if (type === "edu") {
			setSearchProductDetailData({
				...searchProductDetailData,
				[type]: value,
				subject: "",
				version: "",
			});
		} else {
			setSearchProductDetailData({
				...searchProductDetailData,
				[type]: value,
			});
		}
	};

	const onSelectBookTag = (path) => {
		const isListen = targetSelectOptions.find((item) => item.value === path).isListen;
		setBookTagPath(path);
		setBookTagIsListen(isListen);
	};

	const checkHandler = (e, item) => {
		const checked = e.target.checked;

		let nextData = [...checkList];
		if (checked) {
			if (nextData.some((data) => data.uid === item.uid)) return;
			nextData = [...nextData, item];
			setCheckedList([...nextData]);
		} else {
			const dataIndex = nextData.findIndex((data) => data.uid === item.uid);
			nextData.splice(dataIndex, 1);
			setCheckedList([...nextData]);
		}
	};

	const IsChecked = (item) => {
		if (checkList.length === 0) return false;
		return checkList.some((data) => data.uid === item.uid);
	};
	const checkListAll = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setCheckedList([...records]);
		} else {
			setCheckedList([]);
		}
	};

	const onFilterChange = (value) => {
		setFilterData(value);
	};
	// setReSubmitLoading(true);
	// await onReSubmitHandle(item);
	// setReSubmitLoading(false);
	const queueReloadFile = () => {
		const retryFile = checkList.filter((item) => item.allowRetry);
		setIsLoading(true);
		Promise.all(retryFile.map((data) => onReSubmitHandle(data))).then(() => {
			setIsLoading(false);
			openNotificationWithIcon("success", "批次重傳完成");
		});
	};

	const queueDeleteFile = () => {
		setIsLoading(true);
		Promise.all(checkList.map((data) => doDeleteQueue(data))).then(() => {
			setIsLoading(false);
			openNotificationWithIcon("success", "批次刪除完成");
			fetchRecords(true);
			setPageState({ ...pageState, currentPage: 1 });
		});
	};

	useEffect(() => {
		fetchRecords(true);
		sendProductDetail(FetchEventType.Fetch);
	}, [filterData, pageState.currentPage, pageState.limit]);

	useEffect(() => {
		if (isFinished === undefined) return;
		const interval = setInterval(() => {
			fetchRecords();
			sendProductDetail(FetchEventType.Fetch);
		}, 1000 * 30);
		if (isFinished) {
			clearInterval(interval);
		}
		return () => clearInterval(interval);
	}, [isFinished]);

	useEffect(() => {
		if (!stateProductDetail.matches(FetchStates.Resolved) || Object.keys(urlParams).length === 0) return;

		const { education, specUID, subject, version, year } = urlParams;
		setSearchProductDetailData({
			...searchProductDetailData,
			year,
			edu: education,
			subject,
			version,
		});
		setSpecUID(specUID);
	}, [stateProductDetail.value]);

	useEffect(() => {
		if (!searchProductDetailData.year) return;
		setSearchProductDetailData({
			...searchProductDetailData,
			subject: "",
			version: "",
		});
		sendProductDetail(FetchEventType.Fetch);
	}, [searchProductDetailData.year]);

	useEffect(() => {
		if (lockRuleSelection) return;
		setSpecUID(null);
	}, [searchProductDetailData, lockRuleSelection]);

	useEffect(() => {
		if (targetSelectOptions.length === 0) return;
		setBookTagPath(targetSelectOptions[0].value);
	}, [targetSelectOptions]);

	return (
		<>
			<UiHomePage>
				<div className="flexStartBox">
					<Breadcrumb data={breadcrumbList} />
				</div>
				<div className="searchToolBar">
					<div className="flexStartBox">
						<Select
							placeholder="請選擇學年度"
							options={filterTypeOptions}
							value={filterData}
							onChange={(val) => {
								onFilterChange(val);
							}}
						/>
					</div>
					<div className="flexEndBox">
						<Button.IconButton variant="green" full={false} iconName="restart_alt" onClick={queueReloadFile}>
							批次重傳檔案
						</Button.IconButton>
						<Button.IconButton variant="red" full={false} iconName="delete_forever" onClick={queueDeleteFile}>
							批次刪除檔案
						</Button.IconButton>
						<Button.IconButton variant="blue" full={false} iconName="cloud_upload" onClick={toggleUploadPopupVisible}>
							上傳試題
						</Button.IconButton>
					</div>
				</div>

				<Modal
					width={600}
					visible={uploadPopup}
					onCancel={toggleUploadPopupVisible}
					onOk={submitFiles}
					title="上傳試題"
					footer={
						<UiButtons>
							<Button variant="white" full={false} onClick={toggleUploadPopupVisible} Key="cancel" loading={isLoading}>
								取消
							</Button>
							<Button
								variant="orange"
								full={false}
								onClick={submitFiles}
								Key="ok"
								loading={isLoading}
								disabled={files.length === 0 || !specUID}>
								確認
							</Button>
						</UiButtons>
					}>
					<UiRuleModalContent>
						<div className="ruleDetail">
							<Select
								value={searchProductDetailData.year}
								disabled={lockRuleSelection}
								options={yearMap}
								placeholder="請選擇年度*"
								onChange={(val) => {
									onUpdateRuleChange("year", val);
								}}
								allowClear={false}
							/>
							<Select
								value={searchProductDetailData.edu || null}
								disabled={lockRuleSelection}
								options={eduMap}
								placeholder="請選擇學制*"
								onChange={(val) => {
									onUpdateRuleChange("edu", val);
								}}
							/>
							<Select
								value={searchProductDetailData.subject || null}
								disabled={lockRuleSelection}
								options={subjectOptions}
								placeholder="請選擇科目*"
								onChange={(val) => {
									onUpdateRuleChange("subject", val);
								}}
							/>
							<Select
								value={searchProductDetailData.version || null}
								disabled={lockRuleSelection}
								options={versionOptions}
								placeholder="請選擇版本*"
								onChange={(val) => {
									onUpdateRuleChange("version", val);
								}}
							/>
						</div>
						<div className="ruleDetail">
							<Select
								value={specUID}
								disabled={lockRuleSelection}
								options={filterSpecList}
								placeholder="請選擇入庫規格*"
								onChange={(val) => {
									setSpecUID(val);
								}}
							/>
						</div>
					</UiRuleModalContent>
					<Upload
						fileList={files}
						multiple={true}
						onChange={changeFileList}
						prompt={
							<>
								僅限上傳999個Microsoft Word 檔<br />
								(副檔名 : .doc/.docx)
							</>
						}
						acceptFileType=".doc,.docx"
					/>
				</Modal>
				{isLoading ? (
					<UiLoadingBox>
						<Loading />
					</UiLoadingBox>
				) : null}
			</UiHomePage>
			<UiTableBox>
				<Table margin="3">
					<Header>
						<Row>
							<Item className="checkboxItem" flex="0.1">
								<Checkbox
									indeterminate={checkList.length !== 0 && !isCheckAll}
									checked={isCheckAll}
									onChange={(event) => {
										checkListAll(event);
									}}
								/>
							</Item>
							<Item flex="2">檔案名稱</Item>
							<Item flex="2">題目UID</Item>
							<Item>檔案狀態</Item>
							<Item>日期</Item>
							<Item>規格名稱</Item>
							<Item>上傳者</Item>
							<Item flex="2.5">操作</Item>
						</Row>
					</Header>
					<Body>
						{records &&
							records.map((item, index) => {
								return (
									<Row key={index}>
										<Item className="checkboxItem" flex="0.1">
											<Checkbox
												checked={IsChecked(item)}
												onChange={(event) => {
													checkHandler(event, item);
												}}
											/>
										</Item>
										<Item flex="2">{item.fileName}</Item>
										<Item flex="2">{item?.itemUID}</Item>
										<Item>
											<UiStatus className={uploadStatusClassName(item.status)}>{item.message}</UiStatus>
										</Item>
										<Item>{format(getTime(new Date(item.systemTime)), "yyyy-MM-dd HH:mm")}</Item>
										<Item>
											{item.specName ? (
												<UiLink
													className="link"
													onClick={() => {
														history.push(`/ruleSearchDetail/${item.specUID}`);
													}}>
													{item.specName}
												</UiLink>
											) : (
												""
											)}
										</Item>
										<Item>{item.userName}</Item>
										<Item flex="2.5">
											<ButtonGroup
												item={item}
												onDetailPopupHandle={toggleDetailVisible}
												onDeleteHandle={deleteHandle}
												onDownloadHandle={downloadHandle}
												onReSubmitHandle={onReSubmitHandle}
											/>
										</Item>
									</Row>
								);
							})}
					</Body>
				</Table>
				<Pagination
					total={totalcount || 0}
					defaultCurrent={1}
					current={pageState.currentPage}
					onChange={pageChange}
					defaultPageSize={pageState.limit}
				/>
			</UiTableBox>

			<UiQuesDetail id="quesDetail">
				<Modal
					visible={detailPopup.visible}
					onCancel={toggleDetailVisible}
					getContainer={document.getElementById("quesDetail")}
					width="75%"
					footer={
						<Pagination
							textcolor="#000"
							total={detailList?.length || 0}
							defaultPageSize={1}
							variant="white"
							current={detailPage}
							onChange={onDetailPageChange}
						/>
					}>
					<UiPopupContainer id="quesTab">
						<Tabs
							defaultActiveKey="1"
							tabBarExtraContent={
								<>
									{targetDetail?.questionPdf ? (
										<Button.IconButton
											variant="blue"
											type="outLined"
											iconName="picture_as_pdf"
											onClick={() => {
												window.open(targetDetail.questionPdf, "_blank");
											}}>
											PDF
										</Button.IconButton>
									) : (
										""
									)}
								</>
							}>
							<Tabs.TabPane
								tab={
									<>
										<Icon name="visibility" />
										檢視更多
									</>
								}
								key="1">
								<div className="container">
									<div className="content">
										<div className="title">題目</div>
										<div className="img">
											<Image
												src={targetDetail?.questionImage || "error"}
												preview={{
													getContainer: document.getElementById("quesTab"),
												}}
												fallback="data:image/png;base64,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"
											/>
										</div>
										<ul className="info">
											<li>
												入庫時間:{" "}
												{targetDetail?.createTime && format(new Date(targetDetail.createTime), "yyyy-MM-dd HH:mm")}
											</li>
											<li>最後修改時間: {targetDetail?.updateTime}</li>
										</ul>
									</div>
									<div className="content">
										<div className="title">基本資料</div>
										<div className="meta">
											編號:
											<span className="metaContent">{targetDetail?.uid}</span>
										</div>
										{targetDetail?.metadata &&
											targetDetail.metadata.map((meta, index) => {
												return (
													<div className="meta" key={index}>
														{`${meta.name}: `}
														{meta.content.map((content, contentIndex) => {
															return (
																<span className="metaContent" key={contentIndex}>
																	{new Set(showCodeList).has(meta.code) ? content.code : content.name}
																</span>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							</Tabs.TabPane>

							<Tabs.TabPane
								tab={
									<>
										<Icon name="widgets" />
										解析狀態
									</>
								}
								key="2">
								<div className="container">
									<div className="content">
										<div className="title">題目</div>
										<div className="bookTag">
											<Select
												label="解析書籤名稱:"
												options={targetSelectOptions}
												value={bookTagPath}
												onChange={(val) => {
													onSelectBookTag(val);
												}}
											/>
										</div>
										<div className="img">
											{bookTagIsListen ? (
												<audio controls src={bookTagPath || "error"}>
													Your browser does not support the
													<code>audio</code> element.
												</audio>
											) : (
												<Image
													src={bookTagPath || "error"}
													preview={{
														getContainer: document.getElementById("quesTab"),
													}}
													fallback="data:image/png;base64,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"
												/>
											)}
										</div>
									</div>
									<div className="content">
										<div className="title">基本資料</div>
										<div className="meta">
											編號:
											<span className="metaContent">{targetDetail?.uid}</span>
										</div>
										{targetDetail?.metadata &&
											targetDetail.metadata.map((meta, index) => {
												return (
													<div className="meta" key={index}>
														{`${meta.name}: `}
														{meta.content.map((content, contentIndex) => {
															return (
																<span className="metaContent" key={contentIndex}>
																	{new Set(showCodeList).has(meta.code) ? content.code : content.name}
																</span>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							</Tabs.TabPane>
							{questionHtml && (
								<Tabs.TabPane tab={"線上測驗解析結果"} key="3">
									<FileCheck key={questionHtml} questionHtml={questionHtml}></FileCheck>
									{/* {
											questionHtml &&
											<>
												<div>{questionHtml.htmlParts.content}</div>
												<div>{questionHtml.htmlParts.answer}</div>
												<div>{questionHtml.htmlParts.analyze}</div>
											</>
										} */}
								</Tabs.TabPane>
							)}
						</Tabs>
					</UiPopupContainer>
				</Modal>
			</UiQuesDetail>
		</>
	);
};
